import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Facebook, Menu, X, ArrowRight, ArrowUpRight, CheckCircle2, ShieldCheck, FileText, BookOpen, Mail, MapPin, Phone, Download, Search, Send, TrendingUp } from 'lucide-react';
const navLinks = [{
  label: 'Approach',
  href: '#approach'
}, {
  label: 'Expertise',
  href: '#expertise'
}, {
  label: 'Engagements',
  href: '#models'
}, {
  label: 'Open Searches',
  href: '#open-searches'
}, {
  label: 'Resources',
  href: '#resources'
}, {
  label: 'About',
  href: '#about'
}];
export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);
  const handleNewsletter = (e: React.FormEvent) => {
    e.preventDefault();
    if (newsletterEmail.trim()) {
      setNewsletterSubmitted(true);
      setNewsletterEmail('');
      setTimeout(() => setNewsletterSubmitted(false), 4000);
    }
  };
  return <div className="w-full min-h-screen bg-th-cream font-sans text-th-ink selection:bg-th-navy selection:text-white" data-id="element-0">
      {/* Utility Bar */}
      <div className="hidden md:block bg-th-navy text-white/80 text-xs" data-id="element-1">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-9 flex items-center justify-between" data-id="element-2">
          <div className="flex items-center gap-6" data-id="element-3">
            <span className="flex items-center gap-1.5" data-id="element-4">
              <MapPin size={12} className="text-th-crimson" data-id="element-5" />
              Minneapolis, MN · Serving clients nationally
            </span>
            <span className="hidden lg:flex items-center gap-1.5" data-id="element-6">
              <Mail size={12} className="text-th-crimson" data-id="element-7" />
              trent@thetrustedhire.com
            </span>
          </div>
          <div className="flex items-center gap-6" data-id="element-8">
            <a href="#resources" className="hover:text-white transition-colors" data-id="element-9">
              Free Resources
            </a>
            <span className="text-white/30" data-id="element-10">|</span>
            <a href="#open-searches" className="hover:text-white transition-colors" data-id="element-11">
              Open Searches
            </a>
          </div>
        </div>
      </div>

      {/* Fixed Header */}
      <header className="sticky top-0 z-50 bg-th-cream/95 backdrop-blur-md border-b border-th-navy/10" data-id="element-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-13">
          <div className="flex items-center justify-between h-20" data-id="element-14">
            {/* Logo */}
            <a href="#hero" className="flex-shrink-0 flex items-center gap-3 group" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/1qmgBWvCoZdFskuUwA7K5H/TH2BLogo.webp" alt="TrustedHire logo" width={40} height={40} className="w-10 h-10 object-contain transition-transform group-hover:scale-105" data-id="element-16" />
              <div className="hidden sm:block leading-none" data-id="element-17">
                <div className="font-serif text-xl text-th-navy" data-id="element-18">
                  TrustedHire
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-th-stone mt-0.5" data-id="element-19">
                  Executive Recruiting
                </div>
              </div>
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-7" data-id="element-20">
              {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-th-ink/70 hover:text-th-crimson transition-colors" data-id="element-21">
                  {link.label}
                </a>)}
            </nav>

            {/* Desktop Right Side */}
            <div className="hidden lg:flex items-center space-x-4" data-id="element-22">
              <a href="#resources" className="text-sm font-medium text-th-navy hover:text-th-crimson transition-colors hidden xl:inline-flex items-center gap-1" data-id="element-23">
                Get Free Guide
                <Download size={14} data-id="element-24" />
              </a>
              <a href="#contact" className="group px-5 py-2.5 bg-th-navy text-white text-sm font-medium hover:bg-th-navy-dark transition-all inline-flex items-center gap-2" data-id="element-25">
                Start a Search
                <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" data-id="element-26" />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-th-navy p-2 -mr-2" aria-label="Toggle menu" data-id="element-27">
              {mobileMenuOpen ? <X size={24} data-id="element-28" /> : <Menu size={24} data-id="element-29" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="lg:hidden bg-th-cream border-t border-th-navy/10 absolute w-full shadow-lg" data-id="element-30">
            <div className="px-6 py-6 space-y-5" data-id="element-31">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block text-base font-medium text-th-ink hover:text-th-crimson transition-colors" data-id="element-32">
                  {link.label}
                </a>)}
              <div className="pt-5 border-t border-th-navy/10 flex flex-col gap-3" data-id="element-33">
                <a href="#resources" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center px-6 py-3 border border-th-navy text-th-navy text-sm font-medium" data-id="element-34">
                  Get Free Mis-Hire Guide
                </a>
                <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center px-6 py-3 bg-th-navy text-white text-sm font-medium" data-id="element-35">
                  Start a Search
                </a>
              </div>
            </div>
          </div>}
      </header>

      {/* Hero Section */}
      <section id="hero" className="relative overflow-hidden bg-gradient-to-b from-th-cream to-th-bone/40" data-id="element-36">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 lg:pt-24 pb-20 lg:pb-32" data-id="element-37">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-38">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="lg:col-span-7 space-y-8" data-id="element-39">
              <div className="inline-flex items-center gap-2.5 text-[11px] font-medium uppercase tracking-[0.2em] text-th-crimson" data-id="element-40">
                <span className="w-8 h-px bg-th-crimson" data-id="element-41"></span>
                <ShieldCheck size={14} data-id="element-42" />
                Minnesota's Boutique Recruiting Firm
              </div>

              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-[80px] leading-[1.05] text-th-navy tracking-tight" data-id="element-43">
                Hiring is too expensive to{' '}
                <span className="italic text-th-crimson" data-id="element-44">get wrong.</span>
              </h1>

              <p className="text-lg lg:text-xl text-th-stone leading-relaxed max-w-xl" data-id="element-45">
                A mis-hire costs you 30% of annual salary, six months of
                momentum, and a team that loses faith in the process.
                TrustedHire helps small and mid-sized organizations fill{' '}
                <span className="text-th-navy font-medium" data-id="element-46">
                  Accounting &amp; Finance, HR, and Operations
                </span>{' '}
                roles with people who actually stay.
              </p>

              {/* CTA Stack */}
              <div className="space-y-4 pt-2" data-id="element-47">
                <div className="flex flex-col sm:flex-row gap-3" data-id="element-48">
                  <a href="#contact" className="group px-7 py-4 bg-th-navy text-white font-medium hover:bg-th-navy-dark transition-all inline-flex items-center justify-center gap-2 shadow-sm" data-id="element-49">
                    Start a Search
                    <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" data-id="element-50" />
                  </a>
                  <a href="#resources" className="group px-7 py-4 bg-white border border-th-navy/20 text-th-navy font-medium hover:border-th-navy hover:bg-th-bone/50 transition-all inline-flex items-center justify-center gap-2" data-id="element-51">
                    <Download size={16} data-id="element-52" />
                    Get the Mis-Hire Guide
                  </a>
                </div>
                <p className="text-xs text-th-stone flex items-center gap-2" data-id="element-53">
                  <span className="w-1 h-1 rounded-full bg-th-crimson" data-id="element-54"></span>
                  16 years recruiting
                  <span className="w-1 h-1 rounded-full bg-th-stone/30" data-id="element-55"></span>5
                  agencies of experience
                  <span className="w-1 h-1 rounded-full bg-th-stone/30" data-id="element-56"></span>
                  92% 2-year retention
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.15
          }} className="lg:col-span-5 relative" data-id="element-57">
              <div className="absolute -inset-2 bg-th-navy/5" data-id="element-58"></div>
              <div className="absolute -inset-1 border border-th-navy/10" data-id="element-59"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cwXTALCgUveHQrWPwKU82J/574FE7DF-CA4B-4C51-9BA7-653DD495344C.png" alt="Trent Sweeney, Founder of TrustedHire" className="relative z-10 w-full h-[520px] object-cover object-top" data-id="element-60" />
              {/* Founder caption card */}
              <div className="absolute -bottom-8 -left-4 lg:-left-8 z-20 bg-white p-6 shadow-2xl border-l-2 border-th-crimson max-w-[260px]" data-id="element-61">
                <div className="text-[10px] uppercase tracking-[0.2em] text-th-crimson mb-2 font-medium" data-id="element-62">
                  Founder
                </div>
                <div className="font-serif text-xl text-th-navy leading-tight" data-id="element-63">
                  Trent Sweeney
                </div>
                <div className="text-xs text-th-stone mt-1" data-id="element-64">
                  16 years · 5 agencies · 300+ placements
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Trusted by strip */}
        <div className="border-t border-th-navy/10 bg-th-cream" data-id="element-65">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6" data-id="element-66">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8" data-id="element-67">
              <span className="text-[11px] uppercase tracking-[0.2em] text-th-stone font-medium whitespace-nowrap" data-id="element-68">
                Trusted across industries
              </span>
              <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-th-navy/60 font-medium" data-id="element-69">
                <span data-id="element-70">Manufacturing</span>
                <span data-id="element-71">Healthcare</span>
                <span data-id="element-72">Professional Services</span>
                <span data-id="element-73">Financial Services</span>
                <span data-id="element-74">Technology</span>
                <span data-id="element-75">Construction</span>
                <span data-id="element-76">Non-Profit</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* By The Numbers */}
      <section className="bg-th-navy text-white py-20 lg:py-24" data-id="element-77">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-78">
          <div className="grid lg:grid-cols-12 gap-12 items-end mb-12" data-id="element-79">
            <div className="lg:col-span-5" data-id="element-80">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-81">
                <span data-id="element-82">I.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-83"></span>
                By the Numbers
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1]" data-id="element-84">
                A track record built one search at a time.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7" data-id="element-85">
              <p className="text-white/70 text-lg leading-relaxed" data-id="element-86">
                These aren't vanity numbers. They represent organizations who
                trusted us with critical hires — and the candidates we placed
                who are still creating impact today.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10" data-id="element-87">
            {[{
            number: '16',
            suffix: 'yrs',
            label: 'Recruiting experience'
          }, {
            number: '300',
            suffix: '+',
            label: 'Placements made'
          }, {
            number: '92',
            suffix: '%',
            label: '2-year retention rate'
          }, {
            number: '42',
            suffix: ' days',
            label: 'Avg. time to slate'
          }].map((stat, i) => <div key={i} className="bg-th-navy p-8 lg:p-10" data-id="element-88">
                <div className="font-serif text-5xl lg:text-7xl text-white flex items-baseline" data-id="element-89">
                  {stat.number}
                  <span className="text-th-crimson text-3xl lg:text-4xl ml-1" data-id="element-90">
                    {stat.suffix}
                  </span>
                </div>
                <div className="text-white/60 text-sm mt-3 leading-snug" data-id="element-91">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* The Approach Section */}
      <section id="approach" className="py-20 lg:py-32 bg-th-cream" data-id="element-92">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-93">
          <div className="grid lg:grid-cols-12 gap-12 mb-16" data-id="element-94">
            <div className="lg:col-span-5" data-id="element-95">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-96">
                <span data-id="element-97">II.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-98"></span>
                The Approach
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-th-navy leading-[1.1]" data-id="element-99">
                Tired of recruiters who treat your business like a transaction?
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end" data-id="element-100">
              <p className="text-lg text-th-stone leading-relaxed" data-id="element-101">
                Most agencies throw resumes at the wall to see what sticks. They
                disappear after the placement is made, leaving you to deal with
                the fallout. After 16 years across 5 different agency settings,
                we built a different model.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-th-navy/10" data-id="element-102">
            {[{
            num: '01',
            title: 'Relationship Driven',
            body: "We invest time to understand your long-term goals, your team's culture, and the kind of person who will thrive in your environment — not just check boxes on a job description."
          }, {
            num: '02',
            title: 'Culture-Fit First',
            body: 'Skills can be taught; culture fit cannot. Every finalist is vetted against the actual norms of your team — how they work, decide, and disagree.'
          }, {
            num: '03',
            title: 'Built for the Long Game',
            body: "We don't ghost at the offer letter. We close the candidate, prep the onboarding, and check in at 30, 60, and 90 days. Still answering the phone at year five."
          }].map(card => <div key={card.num} className="bg-th-cream p-8 lg:p-10 hover:bg-th-bone/40 transition-colors" data-id="element-103">
                <div className="font-serif text-3xl text-th-crimson mb-6" data-id="element-104">
                  {card.num}
                </div>
                <h3 className="font-serif text-2xl text-th-navy mb-3" data-id="element-105">
                  {card.title}
                </h3>
                <p className="text-th-stone leading-relaxed" data-id="element-106">{card.body}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section id="expertise" className="py-20 lg:py-32 bg-th-bone/40" data-id="element-107">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-108">
          <div className="grid lg:grid-cols-12 gap-16 items-start" data-id="element-109">
            <div className="lg:col-span-5 lg:sticky lg:top-32" data-id="element-110">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-111">
                <span data-id="element-112">III.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-113"></span>
                Expertise
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-th-navy mb-6 leading-[1.1]" data-id="element-114">
                Three functions. Deep networks. No dabbling.
              </h2>
              <p className="text-lg text-th-stone mb-8 leading-relaxed" data-id="element-115">
                We don't try to recruit for everything. We go deep where it
                matters — the operational backbone of your business.
              </p>
              <a href="#contact" className="group inline-flex items-center gap-2 text-th-navy font-medium hover:text-th-crimson transition-colors border-b border-th-navy/30 hover:border-th-crimson pb-1" data-id="element-116">
                Discuss your role
                <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-117" />
              </a>
            </div>

            <div className="lg:col-span-7 space-y-12" data-id="element-118">
              {[{
              title: 'Accounting & Finance',
              tagline: 'From staff accountant to CFO.',
              body: 'Finance roles where the wrong hire shows up in the audit, the close, or the board pack — three places you cannot afford a surprise. We place leaders who bring rigor, judgment, and strategic clarity.',
              roles: ['CFO', 'Controller', 'VP Finance', 'FP&A Director', 'Sr. Financial Analyst', 'Senior Accountant']
            }, {
              title: 'Human Resources',
              tagline: 'From generalist to CHRO.',
              body: 'HR hires that have to walk into broken processes, low trust, or a culture rebuild — and earn the room within 90 days. We find the operators who shape culture and drive performance.',
              roles: ['CHRO', 'VP People', 'HR Director', 'HRBP', 'Talent Acquisition Lead', 'Compensation']
            }, {
              title: 'Operations',
              tagline: 'From manager to COO.',
              body: 'Operators who can scale a team, fix a process, and survive cross-functional politics — not just the ones with the right resume. Discipline and care, at every level.',
              roles: ['COO', 'VP Operations', 'Director of Operations', 'Supply Chain Lead', 'Plant Manager', 'Continuous Improvement']
            }].map(domain => <div key={domain.title} className="group pb-12 border-b border-th-navy/15 last:border-0" data-id="element-119">
                  <div className="flex items-baseline justify-between mb-3 gap-4" data-id="element-120">
                    <h3 className="font-serif text-3xl lg:text-4xl text-th-navy group-hover:text-th-crimson transition-colors" data-id="element-121">
                      {domain.title}
                    </h3>
                    <span className="text-sm text-th-stone italic shrink-0" data-id="element-122">
                      {domain.tagline}
                    </span>
                  </div>
                  <p className="text-th-stone leading-relaxed mb-5" data-id="element-123">
                    {domain.body}
                  </p>
                  <div className="flex flex-wrap gap-2" data-id="element-124">
                    {domain.roles.map(role => <span key={role} className="text-xs bg-white text-th-navy px-3 py-1.5 border border-th-navy/15" data-id="element-125">
                        {role}
                      </span>)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Models Section */}
      <section id="models" className="py-20 lg:py-32 bg-th-navy text-white" data-id="element-126">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-127">
          <div className="grid lg:grid-cols-12 gap-12 mb-16" data-id="element-128">
            <div className="lg:col-span-5" data-id="element-129">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-130">
                <span data-id="element-131">IV.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-132"></span>
                Engagements
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1]" data-id="element-133">
                Three ways to work together.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end" data-id="element-134">
              <p className="text-white/70 text-lg leading-relaxed" data-id="element-135">
                Same rigor across all three. You pick the structure that matches
                the role, the urgency, and the budget.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-white/10" data-id="element-136">
            {[{
            title: 'Retained Search',
            tag: 'Best for leadership & confidential roles',
            features: ['Exclusive partnership', 'Retainer + milestone payments', 'Guaranteed timeline', 'Replacement guarantee']
          }, {
            title: 'Engaged Search',
            tag: 'Best for critical mid-level roles',
            features: ['Modest engagement fee', 'Reduced success fee on hire', 'Dedicated focus', 'Hybrid commitment'],
            featured: true
          }, {
            title: 'Contingent Search',
            tag: 'Best for non-exclusive or volume',
            features: ['No upfront cost', 'Pay only on hire', 'Same vetting standard', 'Non-exclusive']
          }].map(model => <div key={model.title} className={`relative p-8 lg:p-10 transition-colors ${model.featured ? 'bg-th-cream text-th-navy' : 'bg-th-navy text-white hover:bg-th-navy-dark'}`} data-id="element-137">
                {model.featured && <div className="absolute -top-3 left-8 bg-th-crimson text-white text-[10px] uppercase tracking-[0.2em] font-medium px-3 py-1" data-id="element-138">
                    Most Popular
                  </div>}
                <h3 className="font-serif text-3xl mb-2" data-id="element-139">{model.title}</h3>
                <div className={`text-xs mb-6 ${model.featured ? 'text-th-crimson' : 'text-white/60'}`} data-id="element-140">
                  {model.tag}
                </div>
                <ul className="space-y-3 mb-8" data-id="element-141">
                  {model.features.map(f => <li key={f} className="flex items-start gap-2 text-sm" data-id="element-142">
                      <CheckCircle2 size={16} className={`mt-0.5 shrink-0 ${model.featured ? 'text-th-crimson' : 'text-th-crimson'}`} data-id="element-143" />
                      <span className={model.featured ? 'text-th-stone' : 'text-white/85'} data-id="element-144">
                        {f}
                      </span>
                    </li>)}
                </ul>
                <a href="#contact" className={`group inline-flex items-center gap-2 text-sm font-medium border-b pb-1 transition-colors ${model.featured ? 'text-th-navy border-th-navy/30 hover:border-th-crimson hover:text-th-crimson' : 'text-white border-white/30 hover:border-th-crimson hover:text-th-crimson'}`} data-id="element-145">
                  Inquire about this model
                  <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-146" />
                </a>
              </div>)}
          </div>
        </div>
      </section>

      {/* Open Searches Section */}
      <section id="open-searches" className="py-20 lg:py-32 bg-th-cream" data-id="element-147">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-148">
          <div className="grid lg:grid-cols-12 gap-12 items-end mb-12" data-id="element-149">
            <div className="lg:col-span-7" data-id="element-150">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-151">
                <span data-id="element-152">V.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-153"></span>
                Open Searches
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-th-navy leading-[1.1]" data-id="element-154">
                Currently in the market.
              </h2>
              <p className="text-th-stone text-lg leading-relaxed mt-4 max-w-2xl" data-id="element-155">
                A selection of roles we're actively recruiting for. Don't see
                yours? Submit your role for a confidential market scan.
              </p>
            </div>
            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:justify-end gap-3" data-id="element-156">
              <a href="#contact" className="px-5 py-3 border border-th-navy text-th-navy text-sm font-medium hover:bg-th-bone transition-colors inline-flex items-center justify-center gap-2" data-id="element-157">
                Submit Your Role
                <Send size={14} data-id="element-158" />
              </a>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-159">
            {[{
            fn: 'Accounting & Finance',
            role: 'Senior Controller',
            location: 'Twin Cities, MN',
            type: 'Retained',
            status: 'Active'
          }, {
            fn: 'Operations',
            role: 'VP of Operations',
            location: 'Greater Minnesota',
            type: 'Retained',
            status: 'Active'
          }, {
            fn: 'Human Resources',
            role: 'Director of People',
            location: 'Remote (US)',
            type: 'Engaged',
            status: 'Active'
          }, {
            fn: 'Accounting & Finance',
            role: 'FP&A Manager',
            location: 'Minneapolis, MN',
            type: 'Engaged',
            status: 'Active'
          }, {
            fn: 'Operations',
            role: 'Plant Manager',
            location: 'Western Wisconsin',
            type: 'Contingent',
            status: 'New'
          }, {
            fn: 'Human Resources',
            role: 'HR Business Partner',
            location: 'St. Paul, MN',
            type: 'Engaged',
            status: 'Active'
          }].map(r => <a key={r.role + r.location} href="#contact" className="group bg-white border border-th-navy/10 p-6 hover:border-th-crimson hover:shadow-md transition-all block" data-id="element-160">
                <div className="flex items-center justify-between mb-4" data-id="element-161">
                  <span className="text-[10px] uppercase tracking-[0.18em] text-th-stone font-medium" data-id="element-162">
                    {r.fn}
                  </span>
                  <span className={`text-[10px] uppercase tracking-[0.15em] font-medium px-2 py-0.5 ${r.status === 'New' ? 'bg-th-crimson text-white' : 'bg-th-bone text-th-navy'}`} data-id="element-163">
                    {r.status}
                  </span>
                </div>
                <h3 className="font-serif text-xl text-th-navy group-hover:text-th-crimson transition-colors mb-2" data-id="element-164">
                  {r.role}
                </h3>
                <div className="flex items-center gap-3 text-sm text-th-stone" data-id="element-165">
                  <span className="flex items-center gap-1" data-id="element-166">
                    <MapPin size={12} data-id="element-167" />
                    {r.location}
                  </span>
                  <span className="text-th-navy/20" data-id="element-168">·</span>
                  <span data-id="element-169">{r.type}</span>
                </div>
                <div className="mt-5 pt-4 border-t border-th-navy/10 flex items-center justify-between text-sm" data-id="element-170">
                  <span className="text-th-navy font-medium" data-id="element-171">
                    Confidential brief
                  </span>
                  <ArrowUpRight size={14} className="text-th-navy group-hover:text-th-crimson group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" data-id="element-172" />
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* Free Resources Section — LOW-FRICTION CTA HUB */}
      <section id="resources" className="py-20 lg:py-32 bg-th-bone/40" data-id="element-173">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-174">
          <div className="grid lg:grid-cols-12 gap-12 items-end mb-12" data-id="element-175">
            <div className="lg:col-span-7" data-id="element-176">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-177">
                <span data-id="element-178">VI.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-179"></span>
                Free Resources
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-th-navy leading-[1.1]" data-id="element-180">
                Tools we use every day. Yours free.
              </h2>
            </div>
            <div className="lg:col-span-5" data-id="element-181">
              <p className="text-th-stone leading-relaxed" data-id="element-182">
                You don't have to be ready to hire to find value here. Real
                tools, real data, drawn from 16 years of recruiting work.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-183">
            {[{
            icon: <FileText size={20} data-id="element-184" />,
            tag: 'PDF · 12 pages',
            title: 'The Mis-Hire Prevention Checklist',
            body: 'A 24-point checklist used in our discovery sessions. Run any open role through it before you post or interview.',
            cta: 'Download Free'
          }, {
            icon: <TrendingUp size={20} data-id="element-185" />,
            tag: 'Report · 2026',
            title: 'Minnesota Compensation Benchmark',
            body: 'Salary ranges and total comp data for Accounting/Finance, HR, and Operations roles across the Twin Cities and greater Minnesota.',
            cta: 'Get the Report'
          }, {
            icon: <BookOpen size={20} data-id="element-186" />,
            tag: 'Newsletter · Monthly',
            title: 'Hiring Intelligence',
            body: 'One short, useful email a month. Market signals, hiring trends, and what we are seeing across Minnesota and national searches.',
            cta: 'Subscribe'
          }].map(r => <div key={r.title} className="group bg-white border border-th-navy/10 p-8 hover:border-th-navy hover:shadow-lg transition-all flex flex-col" data-id="element-187">
                <div className="w-11 h-11 bg-th-bone flex items-center justify-center text-th-navy mb-6" data-id="element-188">
                  {r.icon}
                </div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-th-crimson font-medium mb-3" data-id="element-189">
                  {r.tag}
                </div>
                <h3 className="font-serif text-2xl text-th-navy mb-3 leading-tight" data-id="element-190">
                  {r.title}
                </h3>
                <p className="text-sm text-th-stone leading-relaxed mb-6 flex-grow" data-id="element-191">
                  {r.body}
                </p>
                <a href="#resource-form" className="group/cta inline-flex items-center gap-2 text-sm font-medium text-th-navy border-b border-th-navy/30 self-start pb-1 hover:border-th-crimson hover:text-th-crimson transition-colors" data-id="element-192">
                  {r.cta}
                  <ArrowRight size={14} className="group-hover/cta:translate-x-0.5 transition-transform" data-id="element-193" />
                </a>
              </div>)}
          </div>

          {/* Inline newsletter form */}
          <div id="resource-form" className="mt-12 bg-th-navy text-white p-8 lg:p-12 grid lg:grid-cols-12 gap-8 items-center" data-id="element-194">
            <div className="lg:col-span-6" data-id="element-195">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-3 font-medium" data-id="element-196">
                Hiring Intelligence
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl leading-tight mb-2" data-id="element-197">
                One useful email a month.
              </h3>
              <p className="text-white/70 text-sm" data-id="element-198">
                Market signals, salary trends, and what we are seeing in
                Minnesota hiring. No fluff, no pitches.
              </p>
            </div>
            <form onSubmit={handleNewsletter} className="lg:col-span-6 flex flex-col sm:flex-row gap-3" data-id="element-199">
              <input type="email" value={newsletterEmail} onChange={e => setNewsletterEmail(e.target.value)} placeholder="you@company.com" required aria-label="Email address" className="flex-grow px-4 py-3.5 bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-th-crimson transition-colors" data-id="element-200" />
              <button type="submit" className="px-6 py-3.5 bg-th-crimson hover:bg-th-crimson-dark text-white font-medium transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-201">
                {newsletterSubmitted ? 'Subscribed ✓' : 'Subscribe'}
                {!newsletterSubmitted && <Send size={14} data-id="element-202" />}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 lg:py-32 bg-th-cream" data-id="element-203">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-204">
          <div className="grid lg:grid-cols-12 gap-12 mb-16" data-id="element-205">
            <div className="lg:col-span-5" data-id="element-206">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium flex items-center gap-2" data-id="element-207">
                <span data-id="element-208">VII.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-209"></span>
                Client Voices
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-th-navy leading-[1.1]" data-id="element-210">
                The numbers are nice. The stories are better.
              </h2>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-211">
            {[{
            quote: 'Trent replaced a controller we had been searching for for 4 months in just over 5 weeks. More importantly, that person is still here two years later and just got promoted. The difference was that he actually understood what we needed culturally, not just on paper.',
            name: 'Sarah Lindberg',
            title: 'CFO, Lindberg Manufacturing'
          }, {
            quote: 'Working with TrustedHire felt nothing like working with the big firms. Trent was in our discovery session for 6 hours, asking better questions than our own leadership team. The shortlist he presented was 3 candidates — and all 3 would have been great hires.',
            name: 'Marcus Chen',
            title: 'COO, Greenline Logistics'
          }, {
            quote: "I've used recruiters for 15 years. Most disappear after the offer is signed. Trent called me on the new hire's 90-day mark to make sure things were tracking. That's the difference.",
            name: 'Jessica Olson',
            title: 'CHRO, Northstar Holdings'
          }].map(t => <figure key={t.name} className="bg-white border border-th-navy/10 p-8 flex flex-col" data-id="element-212">
                <div className="font-serif text-5xl text-th-crimson leading-none mb-4" data-id="element-213">
                  &ldquo;
                </div>
                <blockquote className="text-th-ink leading-relaxed text-[15px] mb-8 flex-grow" data-id="element-214">
                  {t.quote}
                </blockquote>
                <figcaption className="border-t border-th-navy/10 pt-5" data-id="element-215">
                  <div className="font-serif text-lg text-th-navy" data-id="element-216">
                    {t.name}
                  </div>
                  <div className="text-th-stone text-sm" data-id="element-217">{t.title}</div>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </section>

      {/* About Trent Section */}
      <section id="about" className="py-20 lg:py-32 bg-th-navy text-white" data-id="element-218">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-219">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-220">
            <div className="lg:col-span-5" data-id="element-221">
              <div className="relative" data-id="element-222">
                <div className="absolute -inset-2 border border-th-crimson/40" data-id="element-223"></div>
                <img src="https://cdn.magicpatterns.com/uploads/cwXTALCgUveHQrWPwKU82J/574FE7DF-CA4B-4C51-9BA7-653DD495344C.png" alt="Trent Sweeney, Founder of TrustedHire" className="relative w-full h-[460px] object-cover object-top" data-id="element-224" />
              </div>
            </div>

            <div className="lg:col-span-7 space-y-6" data-id="element-225">
              <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson font-medium flex items-center gap-2" data-id="element-226">
                <span data-id="element-227">VIII.</span>
                <span className="w-8 h-px bg-th-crimson" data-id="element-228"></span>
                Who's behind it
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1]" data-id="element-229">
                I've been recruiting for 16 years.{' '}
                <span className="italic text-th-crimson" data-id="element-230">
                  I still answer my own phone.
                </span>
              </h2>
              <div className="space-y-4 text-white/80 leading-relaxed" data-id="element-231">
                <p data-id="element-232">
                  I started TrustedHire because, after 16 years and five agency
                  environments, I knew exactly what worked — and what didn't.
                  The boutique firms got the relationships right but couldn't
                  scale. The big shops scaled but treated every search like a
                  transaction. Neither was what small and mid-sized
                  organizations actually needed.
                </p>
                <p data-id="element-233">
                  TrustedHire is the version I'd want to hire. Deep functional
                  expertise in Accounting &amp; Finance, HR, and Operations. A
                  process built for culture fit. And a recruiter who's still in
                  your corner long after the placement check clears.
                </p>
              </div>
              <p className="font-serif text-xl text-white italic pt-2" data-id="element-234">
                — Trent Sweeney, Founder
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-white/10" data-id="element-235">
                {[{
                n: '16',
                l: 'Years recruiting'
              }, {
                n: '5',
                l: 'Agencies'
              }, {
                n: '300+',
                l: 'Placements'
              }, {
                n: 'MN',
                l: 'Headquartered'
              }].map(s => <div key={s.l} data-id="element-236">
                    <div className="font-serif text-2xl text-white" data-id="element-237">{s.n}</div>
                    <div className="text-xs text-white/60 mt-1" data-id="element-238">{s.l}</div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA — CTA LADDER */}
      <section id="contact" className="py-20 lg:py-32 bg-th-cream" data-id="element-239">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center" data-id="element-240">
          <div className="text-[11px] uppercase tracking-[0.2em] text-th-crimson mb-4 font-medium" data-id="element-241">
            <span className="inline-flex items-center gap-2" data-id="element-242">
              <span className="w-8 h-px bg-th-crimson" data-id="element-243"></span>
              Let's Talk
              <span className="w-8 h-px bg-th-crimson" data-id="element-244"></span>
            </span>
          </div>
          <h2 className="font-serif text-4xl lg:text-6xl text-th-navy leading-[1.05] mb-6" data-id="element-245">
            Stop staring at the{' '}
            <span className="italic text-th-crimson" data-id="element-246">open req.</span>
          </h2>
          <p className="text-lg text-th-stone leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-247">
            Whether you're ready to engage on a search or just want to compare
            notes on the market, there's a way to start. Pick the one that
            matches where you are.
          </p>

          <div className="grid md:grid-cols-3 gap-px bg-th-navy/10 text-left" data-id="element-248">
            {/* High intent */}
            <div className="bg-white p-8 flex flex-col" data-id="element-249">
              <div className="text-[10px] uppercase tracking-[0.2em] text-th-crimson font-medium mb-3" data-id="element-250">
                Ready to hire
              </div>
              <h3 className="font-serif text-2xl text-th-navy mb-3" data-id="element-251">
                Book a Discovery Call
              </h3>
              <p className="text-sm text-th-stone leading-relaxed mb-6 flex-grow" data-id="element-252">
                30 minutes. We'll talk about the role, the market, and whether
                we're the right fit. No pipeline pitch.
              </p>
              <a href="mailto:trent@thetrustedhire.com?subject=Discovery%20Call%20Request" className="group inline-flex items-center justify-center gap-2 px-5 py-3 bg-th-navy text-white text-sm font-medium hover:bg-th-navy-dark transition-colors" data-id="element-253">
                Schedule Call
                <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" data-id="element-254" />
              </a>
            </div>

            {/* Mid intent */}
            <div className="bg-white p-8 flex flex-col" data-id="element-255">
              <div className="text-[10px] uppercase tracking-[0.2em] text-th-crimson font-medium mb-3" data-id="element-256">
                Exploring options
              </div>
              <h3 className="font-serif text-2xl text-th-navy mb-3" data-id="element-257">
                Request a Free Market Scan
              </h3>
              <p className="text-sm text-th-stone leading-relaxed mb-6 flex-grow" data-id="element-258">
                Send us a role. We'll send back a 1-page market overview within
                48 hours — comp ranges, candidate volume, timing.
              </p>
              <a href="mailto:trent@thetrustedhire.com?subject=Market%20Scan%20Request" className="group inline-flex items-center justify-center gap-2 px-5 py-3 bg-white border border-th-navy text-th-navy text-sm font-medium hover:bg-th-bone transition-colors" data-id="element-259">
                Request Scan
                <Search size={14} data-id="element-260" />
              </a>
            </div>

            {/* Low intent */}
            <div className="bg-white p-8 flex flex-col" data-id="element-261">
              <div className="text-[10px] uppercase tracking-[0.2em] text-th-crimson font-medium mb-3" data-id="element-262">
                Just curious
              </div>
              <h3 className="font-serif text-2xl text-th-navy mb-3" data-id="element-263">
                Grab the Mis-Hire Guide
              </h3>
              <p className="text-sm text-th-stone leading-relaxed mb-6 flex-grow" data-id="element-264">
                A 12-page checklist used in every TrustedHire discovery session.
                Use it on your next open role.
              </p>
              <a href="#resources" className="group inline-flex items-center justify-center gap-2 px-5 py-3 bg-white border border-th-navy/30 text-th-navy text-sm font-medium hover:border-th-navy hover:bg-th-bone transition-colors" data-id="element-265">
                Download Free
                <Download size={14} data-id="element-266" />
              </a>
            </div>
          </div>

          <p className="text-sm text-th-stone mt-10" data-id="element-267">
            Or just email{' '}
            <a href="mailto:trent@thetrustedhire.com" className="text-th-navy font-medium underline decoration-th-crimson decoration-2 underline-offset-4 hover:text-th-crimson transition-colors" data-id="element-268">
              trent@thetrustedhire.com
            </a>
            .
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-th-navy text-white pt-16 pb-8" data-id="element-269">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-270">
          <div className="grid md:grid-cols-12 gap-12 mb-12 pb-12 border-b border-white/10" data-id="element-271">
            {/* Brand */}
            <div className="md:col-span-5" data-id="element-272">
              <div className="flex items-center gap-3 mb-5" data-id="element-273">
                <div className="w-11 h-11 rounded bg-white p-1.5 flex items-center justify-center" data-id="element-274">
                  <img src="https://cdn.magicpatterns.com/uploads/1qmgBWvCoZdFskuUwA7K5H/TH2BLogo.webp" alt="TrustedHire logo" width={32} height={32} className="w-full h-full object-contain" data-id="element-275" />
                </div>
                <div className="leading-none" data-id="element-276">
                  <div className="font-serif text-2xl text-white" data-id="element-277">
                    TrustedHire
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1" data-id="element-278">
                    Executive Recruiting
                  </div>
                </div>
              </div>
              <p className="text-white/70 text-sm leading-relaxed max-w-sm mb-6" data-id="element-279">
                A Minnesota boutique recruiting firm. Long-term relationships,
                culture-first hiring, flexible engagement models. Specializing
                in Accounting &amp; Finance, HR, and Operations.
              </p>
              <div className="flex gap-3" data-id="element-280">
                <a href="https://linkedin.com/company/trusted-hire/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-th-crimson hover:border-th-crimson transition-colors" data-id="element-281">
                  <Linkedin size={16} data-id="element-282" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61586932152683" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 border border-white/20 flex items-center justify-center hover:bg-th-crimson hover:border-th-crimson transition-colors" data-id="element-283">
                  <Facebook size={16} data-id="element-284" />
                </a>
              </div>
            </div>

            {/* Explore */}
            <div className="md:col-span-2" data-id="element-285">
              <h4 className="font-medium mb-4 text-white tracking-wide text-sm" data-id="element-286">
                Explore
              </h4>
              <ul className="space-y-2.5 text-sm text-white/60" data-id="element-287">
                <li data-id="element-288">
                  <a href="#approach" className="hover:text-white transition-colors" data-id="element-289">
                    Approach
                  </a>
                </li>
                <li data-id="element-290">
                  <a href="#expertise" className="hover:text-white transition-colors" data-id="element-291">
                    Expertise
                  </a>
                </li>
                <li data-id="element-292">
                  <a href="#models" className="hover:text-white transition-colors" data-id="element-293">
                    Engagements
                  </a>
                </li>
                <li data-id="element-294">
                  <a href="#open-searches" className="hover:text-white transition-colors" data-id="element-295">
                    Open Searches
                  </a>
                </li>
                <li data-id="element-296">
                  <a href="#about" className="hover:text-white transition-colors" data-id="element-297">
                    About
                  </a>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div className="md:col-span-2" data-id="element-298">
              <h4 className="font-medium mb-4 text-white tracking-wide text-sm" data-id="element-299">
                Resources
              </h4>
              <ul className="space-y-2.5 text-sm text-white/60" data-id="element-300">
                <li data-id="element-301">
                  <a href="#resources" className="hover:text-white transition-colors" data-id="element-302">
                    Mis-Hire Checklist
                  </a>
                </li>
                <li data-id="element-303">
                  <a href="#resources" className="hover:text-white transition-colors" data-id="element-304">
                    Comp Benchmark
                  </a>
                </li>
                <li data-id="element-305">
                  <a href="#resources" className="hover:text-white transition-colors" data-id="element-306">
                    Newsletter
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="md:col-span-3" data-id="element-307">
              <h4 className="font-medium mb-4 text-white tracking-wide text-sm" data-id="element-308">
                Contact
              </h4>
              <ul className="space-y-3 text-sm text-white/60" data-id="element-309">
                <li className="flex items-start gap-2.5" data-id="element-310">
                  <MapPin size={14} className="text-th-crimson mt-0.5 shrink-0" data-id="element-311" />
                  <span data-id="element-312">
                    Minneapolis, MN
                    <br data-id="element-313" />
                    Serving clients nationally
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-314">
                  <Mail size={14} className="text-th-crimson mt-0.5 shrink-0" data-id="element-315" />
                  <a href="mailto:trent@thetrustedhire.com" className="hover:text-white transition-colors" data-id="element-316">
                    trent@thetrustedhire.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-317">
            <p className="text-xs text-white/40" data-id="element-318">
              © {new Date().getFullYear()} TrustedHire LLC. All rights
              reserved.
            </p>
            <div className="flex gap-6 text-xs text-white/40" data-id="element-319">
              <a href="#" className="hover:text-white transition-colors" data-id="element-320">
                Privacy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-321">
                Terms
              </a>
              <span data-id="element-322">Minneapolis · Made for Minnesota.</span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}